// Portfolio listing shared by the home page showcase and /projects. Case study
// write-ups live in pages/ProjectDetail.js, keyed by slug.
export const projects = [
  {
    id: 11,
    slug: 'plush-club',
    title: 'Plush Club',
    category: 'Game / Mobile',
    description: 'A cozy 3D claw machine game with real physics. Catch plush friends, tear open foil prize packs and fill your album.',
    problem: 'Most mobile claw games fake the grab with a dice roll, so a catch feels random instead of earned. The goal was a claw where aim, grip and timing decide what you win.',
    image_url: '/images/plushclub-cover.jpg',
    technologies: ['Expo', 'React Native', 'React Three Fiber', 'Rapier', 'Blender', 'Cloudflare Workers'],
    demo_url: 'https://plushclub.app',
    year: '2026'
  },
  {
    id: 7,
    slug: 'halo-ce',
    title: 'Halo CE',
    category: 'Game / Multiplayer',
    description: 'A browser multiplayer recreation of Halo: Combat Evolved. Sixteen-player matches on Blood Gulch and Guardian, with no download.',
    problem: 'Classic Halo multiplayer meant shared hardware, an install, and everyone owning the game. The goal was a link you send a friend that drops them straight into Blood Gulch.',
    image_url: '/images/halo-ce-cover.jpg',
    technologies: ['Three.js', 'TypeScript', 'Cloudflare Durable Objects', 'WebSockets', 'Blender'],
    demo_url: 'https://nothalo.lol',
    year: '2026'
  },
  {
    id: 6,
    slug: 'hoa-right',
    title: 'HOA Right',
    category: 'SaaS / Mobile',
    description: 'Modular HOA management with a directory, work orders, packages, messaging and a shared calendar, on phone, tablet and desktop.',
    problem: 'HOA boards ran their communities on spreadsheets, group texts and paper logs, and the software on offer bundled dozens of features they would never use.',
    image_url: '/images/hoaright-cover.jpg',
    technologies: ['Expo', 'React Native', 'Supabase', 'Cloudflare R2', 'Tamagui'],
    demo_url: 'https://hoaright.com',
    year: '2026'
  },
  {
    id: 10,
    slug: 'notchdeck',
    title: 'NotchDeck',
    category: 'macOS App',
    description: 'Notes, tasks and a pomodoro timer that live inside the MacBook notch. Hover the notch, get your stuff, move on.',
    problem: 'A quick note, a to-do list and a focus timer usually mean three apps and constant window switching, while the notch sits at the top of the screen doing nothing.',
    image_url: '/images/notchdeck-cover.jpg',
    technologies: ['Swift', 'SwiftUI', 'Sparkle', 'GitHub Actions'],
    demo_url: 'https://github.com/cadenburleson/notchdeck/releases/latest',
    year: '2026'
  },
  {
    id: 8,
    slug: 'called-or-not',
    title: 'Called or Not',
    category: 'SaaS / Automation',
    description: 'Calls your court-ordered drug-testing hotline every morning, enters your code, listens to the recording and texts you whether today is a test day.',
    problem: 'People on testing programs have to call a color hotline every single day, and one missed call can mean a violation. The existing service charges $14 a month.',
    image_url: '/images/calledornot-cover.jpg',
    technologies: ['Astro', 'Cloudflare Workers', 'Twilio', 'Claude', 'Stripe'],
    demo_url: 'https://calledornot.com',
    year: '2026'
  },
  {
    id: 9,
    slug: 'shotscraft',
    title: 'ShotsCraft',
    category: 'Open Source / Tool',
    description: 'A free, open-source studio for App Store screenshots and marketing videos, with 3D device mockups, keyframe animation and multi-language export.',
    problem: 'App Store screenshots and launch videos usually mean a paid design tool, a separate video editor, and redoing everything for each language.',
    image_url: '/images/shotscraft-cover.jpg',
    technologies: ['JavaScript', 'Three.js', 'ffmpeg.wasm', 'IndexedDB'],
    demo_url: 'https://shotscraft.com',
    year: '2026'
  },
  {
    id: 5,
    slug: 'bricked-up',
    title: 'BrickedUp',
    category: 'Marketplace',
    description: 'The construction jobs marketplace built for the trades. No agency fees, verified portfolios, and better credit as your rating grows.',
    problem: 'Construction workers and contractors had no reliable way to connect without going through expensive staffing agencies that took a cut from both sides.',
    image_url: '/images/bricked-up-cover.jpg',
    technologies: ['React', 'Node.js', 'Supabase', 'Stripe'],
    demo_url: 'https://bricked-up.com',
    year: '2025'
  },
  {
    id: 4,
    slug: 'byheadless',
    title: 'Byheadless',
    category: 'SaaS / CMS',
    description: 'A headless CMS that lets clients create pages and blog posts through a dead-simple interface — dropped into any project with a single line of code.',
    problem: 'Clients needed the ability to manage their own content without touching code, and developers needed a CMS they could integrate instantly without a multi-day setup.',
    image_url: '/images/byheadless-cover.jpg',
    technologies: ['React', 'Node.js', 'Supabase', 'REST API'],
    demo_url: 'https://byheadless.com',
    year: '2025'
  },
  {
    id: 1,
    slug: 'dungindragin',
    title: 'DunginDragin',
    category: 'AI / Game',
    description: 'AI-powered Dungeons & Dragons adventure platform with infinite procedurally generated worlds.',
    problem: 'Tabletop RPG players wanted dynamic, personalized storytelling without needing a human DM or a group available at the same time.',
    image_url: 'https://www.dungindragin.com/images/og-image.png',
    technologies: ['Google Gemini AI', 'React', 'Node.js'],
    demo_url: 'https://www.dungindragin.com',
    year: '2024'
  },
  {
    id: 2,
    slug: 'fitnitapp',
    title: 'FitNit App',
    category: 'Mobile / Health',
    description: 'Comprehensive fitness and nutrition tracking app that helps users achieve their health goals.',
    problem: 'Existing fitness apps required too much manual input and felt like a chore — killing user retention after the first week.',
    image_url: 'https://fitnitapp.com/assets/feature-image.jpg',
    technologies: ['React Native', 'Node.js', 'PostgreSQL', 'OpenAI'],
    demo_url: 'https://fitnitapp.com',
    year: '2024'
  },
  {
    id: 3,
    slug: 'hard-ship',
    title: 'Hard-Ship',
    category: 'Web Application',
    description: 'Endurance and adventure platform designed to push users beyond their limits.',
    problem: 'Adventure athletes had no unified platform to plan expeditions, track performance, and compete with a global community.',
    image_url: '/images/hard-ship-cover.jpg',
    technologies: ['Next.js', 'Supabase', 'Tailwind CSS', 'Mapbox'],
    year: '2024'
  }
];
